import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalSearchEvents } from '@/components/global-search/machines/globalSearchMachine';
import { globalSearchHotkeyHandlers } from '@/components/global-search/utils';
import usePosthogTracking from '@/hooks/usePosthogTracking';

type UseKeyboardNavigationProps = {
  isOpen: boolean;
  send: (event: GlobalSearchEvents) => void;
};

export function useKeyboardNavigation({ isOpen, send }: UseKeyboardNavigationProps) {
  const { trackEvent } = usePosthogTracking();
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const keyHandlers = globalSearchHotkeyHandlers({ isOpen, send, trackEvent, navigate });
      const handler = keyHandlers(event);
      if (handler) {
        handler();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, navigate, send, trackEvent]);
}
